import BackgroundImage from "../../assets/images/login_bg.jpg"
import CrewMamaBackgroundImage from "../../assets/images/crewmama_login_bg.jpg"
import { getCurrentHost } from "../../utils/getHost"
import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  dialogPaper: {
    backgroundImage: `url(${
      getCurrentHost() === "crewmama"
        ? CrewMamaBackgroundImage
        : BackgroundImage
    })`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
    padding: "0px",
    margin: "0px",
    "@media (max-width: 568px)": {
      backgroundSize: "cover",
    },
  },
  spacer: {
    height: "20px",
  },
}))

export default styles
